export class ExternalMAMServiceProvider {
  constructor(
    public id: number,
    public name: string,
    public logo: string,
    public description: string,
    public generalFields: object,
  ) {}

  public static urlName(s: string): string {
    if (!s) s = this.name;
    return s.toLowerCase().replaceAll(" ", "-");
  }
}
